module.exports = __webpack_public_path__ + "img/02.f6364411.png";